import { render } from "./PhotoGallery.vue?vue&type=template&id=48229e48&ts=true"
import script from "./PhotoGallery.vue?vue&type=script&lang=ts"
export * from "./PhotoGallery.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/vmchs.frontend/vmchs.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__